<template>
  <div class="relative">
    <div
      ref="scrollContainer"
      :class="{
            'relative max-w-full overflow-x-auto gradient-scroll': direction === 'horizontal',
            'relative max-h-full overflow-y-auto gradient-scroll': direction === 'vertical',
            'no-scrollbar': !showScrollbar,
        }"
    >
      <slot />
    </div>

    <transition name="fade">
      <GradientFade
        v-if="showStartGradient"
        :direction="startDirection"
        :size="gradientSize"
        :startColor="gradientStartColor"
        :endColor="gradientEndColor"
      />
    </transition>

    <transition name="fade">
      <GradientFade
        v-if="showEndGradient"
        :direction="endDirection"
        :size="gradientSize"
        :startColor="gradientStartColor"
        :endColor="gradientEndColor"
      />
    </transition>
  </div>
</template>

<script>
import GradientFade from "./GradientFade";
import oppositeDirection from "@/utils/oppositeDirection";

export default {
  name: "GradientScroll",

  components: { GradientFade },

  props: {
    direction: { type: String, default: "vertical" },
    gradientStartColor: { type: String, default: "rgba(255, 255, 255, 0)" },
    gradientEndColor: { type: String, default: "rgba(255, 255, 255, 1)" },
    gradientSize: { type: Number, default: 150 },
    showScrollbar: { type: Boolean, required: false, default: true }
  },

  computed: {
    showStartGradient() {
      return this.isScrolledToStart === false;
    },

    showEndGradient() {
      return this.isScrolledToEnd === false;
    },

    startDirection() {
      return this.direction === "horizontal" ? "left" : "top";
    },

    endDirection() {
      return oppositeDirection(this.startDirection);
    }
  },

  data() {
    return {
      isScrolledToStart: null,
      isScrolledToEnd: null,
      scrollHandler: null
    };
  },

  methods: {
    checkScroll() {
      const el = this.$refs.scrollContainer;

      this.isScrolledToEnd =
        this.direction === "horizontal"
          ? el.scrollLeft + el.offsetWidth >= el.scrollWidth
          : el.scrollTop + el.offsetHeight >= el.scrollHeight;

      this.isScrolledToStart =
        this.direction === "horizontal"
          ? el.scrollLeft === 0
          : el.scrollTop === 0;
    },
    startDragScroll() {
      let isDown = false;
      let startX;
      let scrollLeft;

      this.$refs.scrollContainer.addEventListener("mousedown", e => {
        isDown = true;
        this.$refs.scrollContainer.classList.add("active");
        startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
        scrollLeft = this.$refs.scrollContainer.scrollLeft;
      });
      this.$refs.scrollContainer.addEventListener("mouseleave", () => {
        isDown = false;
      });
      this.$refs.scrollContainer.addEventListener("mouseup", () => {
        isDown = false;
      });
      this.$refs.scrollContainer.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
        const walk = (x - startX) * 3;
        this.$refs.scrollContainer.scrollLeft = scrollLeft - walk;
      });
    },

    killDragScroll() {
      this.$refs.scrollContainer.removeEventListener("mousedown");
      this.$refs.scrollContainer.removeEventListener("mouseleave");
      this.$refs.scrollContainer.removeEventListener("mouseup");
      this.$refs.scrollContainer.removeEventListener("mousemove");
    }
  },

  mounted() {
    this.$refs.scrollContainer.addEventListener(
      "scroll",
      (this.scrollHandler = () => this.checkScroll())
    );
    this.startDragScroll();
    setTimeout(this.checkScroll, 600);
    window.addEventListener("resize", this.checkScroll);
  },

  beforeDestroy() {
    if (this.scrollHandler) {
      this.$refs.scrollContainer.removeEventListener(
        "scroll",
        this.scrollHandler
      );
    }
    window.removeEventListener("resize", this.checkScroll);
  }
};
</script>

<style>
.no-scrollbar {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.no-scrollbar::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
</style>